const REDIRECT_KEY = "redirect_after_login";

const PUBLIC_PATHS = [
  "/",
  "/login",
  "/auth",
  "/logout",
  "/erro",
  "/acesso-negado",
];

const isPublicPath = (url) => {
  if (!url) return true;
  const path = url.split("?")[0];
  return PUBLIC_PATHS.includes(path);
};

export const setRedirectUrl = (url) => {
  if (!url || !url.trim() || isPublicPath(url)) return;
  window.sessionStorage.setItem(REDIRECT_KEY, url.trim());
};

export const getAndClearRedirectUrl = () => {
  const url = window.sessionStorage.getItem(REDIRECT_KEY);
  window.sessionStorage.removeItem(REDIRECT_KEY);
  return url;
};
